import { render, staticRenderFns } from "./MStyle.vue?vue&type=template&id=8d24a1a8&"
import script from "./MStyle.vue?vue&type=script&lang=js&"
export * from "./MStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports